import TwoColumnContainer from './components/TwoColumnContainer';

const MultiColumnBuilder = ({
  iconVisible = false,
  iconEditable = false,
  colorEditable = false,
  ...props
}) => {
  return <TwoColumnContainer {...props} />;
};

export default MultiColumnBuilder;
